module.exports = __webpack_public_path__ + "img/jy.766d90d0.png";